/**
 * Maps route paths to entity types for custom fields
 */
import { CUSTOM_FIELD_ENTITY } from '../modules/custom-fields/entityTypes';

export const getEntityTypeFromRoute = (routePath: string): string | null => {
  const routeMap: Record<string, string> = {
    '/clients': CUSTOM_FIELD_ENTITY.CLIENT,
    '/todos': CUSTOM_FIELD_ENTITY.TODO,
    '/todos_monthly_view': CUSTOM_FIELD_ENTITY.TODO,
    '/appointments': CUSTOM_FIELD_ENTITY.APPOINTMENT,
  };

  if (routeMap[routePath]) {
    return routeMap[routePath];
  }

  for (const [key, entityType] of Object.entries(routeMap)) {
    if (routePath.includes(key.replace('/', ''))) {
      return entityType;
    }
  }

  return null;
};

/**
 * Maps module title to entity type
 */
export const getEntityTypeFromTitle = (title: string): string | null => {
  const titleMap: Record<string, string> = {
    Organizations: CUSTOM_FIELD_ENTITY.CLIENT,
    People: CUSTOM_FIELD_ENTITY.CLIENT_CONTACT,
    Clients: CUSTOM_FIELD_ENTITY.CLIENT,
    'Client Contacts': CUSTOM_FIELD_ENTITY.CLIENT_CONTACT,
    Todos: CUSTOM_FIELD_ENTITY.TODO,
    Appointments: CUSTOM_FIELD_ENTITY.APPOINTMENT,
  };

  return titleMap[title] || null;
};
